import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Wrapper = styled.div`
  display: flex;
  
  * {
   scroll-behavior: smooth;
  }

  *::-webkit-scrollbar {
    width: .7rem;
  }

*::-webkit-scrollbar-thumb {
  background-color: #c4c4c4df;
  border-radius: .6rem;
  background-clip: padding-box;
}


*::-webkit-scrollbar-button:single-button {
      background-color: transparent;
      display: block;
      border-style: solid;
      height: 6px;
    }
    /* Up */
    *::-webkit-scrollbar-button:single-button:vertical:decrement {
      border-width: 0 6px 6px 6px;
      border-radius: 0 1px 1px 1px;
      border-color: transparent transparent #c4c4c4df transparent;
    }

    ::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
      border-color: transparent transparent #c4c4c4df transparent;
    }
    /* Down */
    *::-webkit-scrollbar-button:single-button:vertical:increment {
      border-width: 6px 6px 0 6px;
      border-radius: 2px 2px 0 2px;
      border-color: #c4c4c4df transparent transparent transparent;
    }

    *::-webkit-scrollbar-button:vertical:single-button:increment:hover {
      border-color: #c4c4c4df transparent transparent transparent;
    }
`;

export const PageContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /* border-radius: .8rem; */
  background-color: #f8f8fb;
`;
